const getCacheableContext = () => ({
  headers: {
    'x-cache': 1,
  },
})

export default getCacheableContext
